<template>
  <div>
    <template v-if="additionalTimeSheet.screen == 'approval'">
      <ApprovalAdditionalTimeSheet />
    </template>
    <template v-else>
      <div id="detail-additional-timesheet">
        <CRow class="row-mobile">
          <CCol class="detail-form">
            <div class="text-center">
              <h4 class="title-header">              
                {{ $t("additional_timeSheet.label") }}
              </h4>
            </div>
            <div class="text-content">
              <label>{{
                $t("fields.additional_timeSheet.request_date")
              }}</label>
              <div class="show-text">{{ additionalTimeSheet.work_date }}</div>
            </div>

            <div class="text-content">
              <label>{{
                $t("fields.additional_timeSheet.created_date")
              }}</label>
              <div class="show-text">
                {{ additionalTimeSheet.created_at | formatDate }}
              </div>
            </div>

            <div class="text-content" v-if="additionalTimeSheet.manager_name">
              <label>{{ $t("additional_timeSheet.manager") }}</label>
              <div class="show-text">
                {{ additionalTimeSheet.manager_name }}
              </div>
            </div>

            <div class="text-content">
              <label>{{ $t("additional_timeSheet.admin") }}</label>
              <div class="show-text">{{ additionalTimeSheet.admin_name }}</div>
            </div>

            <div class="text-content">
              <label>{{ $t("additional_timeSheet.check_in_real") }}</label>
              <div class="show-text">
                {{ additionalTimeSheet.start_time_real }}
              </div>
            </div>

            <div class="text-content">
              <label>{{ $t("additional_timeSheet.check_out_real") }}</label>
              <div class="show-text">
                {{ additionalTimeSheet.end_time_real }}
              </div>
            </div>

            <div class="text-content">
              <label>{{ $t("additional_timeSheet.check_in_request") }}</label>
              <div class="show-text">
                {{ additionalTimeSheet.start_time_request }}
              </div>
            </div>

            <div class="text-content">
              <label>{{ $t("additional_timeSheet.check_out_request") }}</label>
              <div class="show-text">
                {{ additionalTimeSheet.end_time_request }}
              </div>
            </div>

            <div class="text-content">
              <label>{{ $t("additional_timeSheet.reason") }}</label>
              <div class="show-text">{{ additionalTimeSheet.reason }}</div>
            </div>

            <div class="text-content">
              <label>{{ $t("additional_timeSheet.evidence") }}</label>
              <div class="image">
                <img
                  v-if="additionalTimeSheet.img_evidence"
                  v-img
                  class="image-evidence"
                  :src="additionalTimeSheet.img_evidence"
                  width="100"
                  height="100"
                />
                <img
                  v-if="additionalTimeSheet.img_evidence2"
                  v-img
                  class="image-evidence"
                  :src="additionalTimeSheet.img_evidence2"
                  width="100"
                  height="100"
                />
              </div>
            </div>
          </CCol>
        </CRow>
        <CRow class="row-mobile">
          <CCol class="detail-form approval-ot">
            <div class="text-label">
              <div class="text-center">
                <h4 class="title-header">
                  {{ $t("overtime.information_approval_ot") }}
                </h4>
              </div>
            </div>
            <div class="text-label-content">
              <div class="table-responsive table-employee-note">
                <table class="table">
                  <thead>
                    <tr>
                      <th class="index">#</th>
                      <th class="create-by">
                        {{ $t("overtime.employee_approval") }}
                      </th>
                      <th class="create-at">
                        {{ $t("overtime.employee_approval_status") }}
                      </th>
                      <th>
                        {{ $t("overtime.employee_approval_note") }}
                      </th>
                      <th>
                        {{ $t("overtime.employee_approval_time") }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item,
                      index) in additionalTimeSheet.request_approve"
                      :key="index"
                    >
                      <th scope="row index">{{ index + 1 }}</th>
                      <td>{{ item.approved_by }}</td>
                      <td class="create-at">
                        {{ $t(`overtime.employee_approval_${item.status}`) }}
                      </td>
                      <td class="comment">{{ item.status != 5 ? item.comment : "" }}</td>
                      <td v-if = "item.status == 2 || item.status == 3 || item.status == 5">
                        {{ formatDate(item.updated_at) }}    
                      </td>
                      <td v-else> </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </CCol>
        </CRow>
        <CRow class="mobile-row-btn">
          <CCol
            md="12"
            sm="12"
            class="text-center"
            v-if="additionalTimeSheet.status == 1"
          >
            <button class="btn btn-success" @click="showEditModal">
              <CIcon
                name="cil-pencil"
                style="margin-right: 3px; border: 1px solid #fff;"
              ></CIcon>
              {{ $t("button.label_action_edit") }}
            </button>
          </CCol>
        </CRow>
      </div>
    </template>
    <EditAdditionalTimesheetModal :visible="isEditModalShow" :id="id" @ok="handleOk" @cancel="handleCancel" />
  </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import moment from "moment";
import ApprovalAdditionalTimeSheet from "./ApprovalAdditionalTimesheet";
import EditAdditionalTimesheetModal from "./Modals/EditAdditionalTimesheetModal.vue";

export default {
  name: "DetailAdditionalTimesheet",
  props: ["id"],
  components: {
    ApprovalAdditionalTimeSheet,
    EditAdditionalTimesheetModal
},
  metaInfo() {
    return {
      title: this.$t("page_title.page_additional_timeSheet_detail"),
      titleTemplate: "%s | " + this.$t("page_title.head_title")
    };
  },
  data() {
    return {
      employeeIdApproval1: "",
      employeeIdApproval2: "",
      listEmployeeIdApproval: [],
      isEditModalShow: false
    };
  },

  computed: {
    ...mapGetters({
      additionalTimeSheet: "additional-timesheet/additionalTimeSheet",
      flagNotification: "commons/flagNotification"
    })
  },

  methods: {
    ...mapActions("additional-timesheet", ["detailOverTimeRequest"]),
    ...mapMutations("commons", ["setNotificationFlag"]),

    async showAdditionalTimeSheet() {
      let additionalTimeSheetId = this.id;
      await this.detailOverTimeRequest(additionalTimeSheetId);
      this.setNotificationFlag(false);
    },

    objectNotNull(obj) {
      if (obj) {
        return Object.keys(obj).length !== 0;
      }
    },

    formatDate(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY HH:mm:ss");
      }
    },
    showEditModal() {
      this.isEditModalShow = true;
    },
    handleOk() {
      this.resetModalParams();
      this.showAdditionalTimeSheet();
    },
    handleCancel() {
      this.resetModalParams();
    },
    resetModalParams() {
      this.isEditModalShow = false;
    }
  },

  async created() {
    await this.showAdditionalTimeSheet();
  },

  watch: {
    async flagNotification(value) {
      if (value) {
        this.listEmployeeIdApproval = [];
        await this.showAdditionalTimeSheet();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 768px) {
  #detail-additional-timesheet {
    .detail-form {
      margin-bottom: 0 !important;
    }
    .table {
      overflow-x: scroll;
      width: 550px;
    }
  }
  .mobile-row-btn {
    margin-right: 0 !important;
    margin-left: 0 !important;
    margin-bottom: 15px !important;
  }
  .detail-form.approval-ot {
    margin: 0 !important;
  }
  .row-mobile {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  #detail-additional-timesheet {
    .detail-form {
      .text-content {
        display: block !important;
        label {
          width: 100% !important;
        }
      }
      .show-text {
        width: 100% !important;
      }
    }
    .title-header {
      margin-bottom: 1rem;
      margin-top: 25px;
    }
  }
}
#detail-additional-timesheet {

  .note-ot {
    text-align: left;

    p.note {
      font-weight: 700;
      color: #ff1a1a;
    }

    label {
      font-weight: 600;
    }

    margin: 20px 0px;
  }

  .detail-form.approval-ot {

    .text-label h4 {
      color: #3c4b64;
      font-weight: 600;
      font-size: 16px;
    }
  }

  .table-employee-note {
    background-color: white;
    margin-top: 20px;

    th {
      font-size: 15px;
    }

    td {
      color: #3c4b64;
    }

    td.comment {
      max-width: 300px;
      word-wrap: break-word;
    }
  }

  .title-header {
    // border-bottom: 2px solid #ea8910;
    padding-bottom: 15px;
    text-transform: uppercase;
    font-weight: 600;
    font-size: 16px;
  }

  .detail-form {
    padding: 0 50px;
    margin-bottom: 30px;

    .text-label h4 {
      color: #333;
      font-weight: 600;
      font-size: 20px;
      // margin-bottom: 30px;

      .icon-text-label {
        margin-left: 8px;
      }
    }

    .text-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;

      .image {
        width: 70%;
      }

      label {
        width: 30%;
        color: #333;
        font-size: 13px;
        font-weight: 600;
      }
    }

    .show-text {
      border: 1px solid #fff;
      background-color: #fff;
      border: 1px solid #ccc;
      width: 70%;
      padding: 0 10px;
      height: 25px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .text-area {
      height: 60px;
    }

    .required {
      color: #dc1313;
      font-size: 13px;
    }
  }

  #toggle-btn {
    height: 37px;
  }
}
</style>
